import { Injectable } from '@angular/core';

@Injectable()
export class SecurityService {

  constructor() { }
  restrictDeveloperTools() {
    // Disable key combinations
    document.addEventListener('keydown', function (e) {
      if (e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key ===
          'J')) ||
        (e.ctrlKey && e.key === 'U') ||
        e.key === 'F5') {
        e.preventDefault();
      }
    });
    // Disable right-click
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });
  }

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/services/security/security.service.ts